import axios from 'axios';
import { getCSRFToken, getSessionId } from '../utils/utils';

// Cache instances by baseURL to avoid creating multiple instances
const instanceCache = new Map();

/**
 * Creates or retrieves a cached axios instance for AMER API calls
 * @param {string} baseURL - Base URL for the API
 * @returns {axios.AxiosInstance} Configured axios instance
 */
export const createAmerAPI = (baseURL) => {
  // Return cached instance if it exists
  if (instanceCache.has(baseURL)) {
    return instanceCache.get(baseURL);
  }

  const amerAPI = axios.create({
    baseURL: baseURL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 20000,
  });

  // Request interceptor to add auth headers
  amerAPI.interceptors.request.use(
    (config) => {
      // Skip adding headers for auth endpoints
      if (config.url?.includes('auth/')) {
        return config;
      }

      // Get token from localStorage
      const token = localStorage.getItem('anonymousToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Get sessionId from localStorage or cookies
      const sessionId = getSessionId();
      if (sessionId) {
        config.headers.Session = sessionId;
      }

      // Get CSRF token from cookies
      const csrfToken = getCSRFToken();
      if (csrfToken) {
        config.headers['X-CSRF-TOKEN'] = csrfToken;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // Cache the instance
  instanceCache.set(baseURL, amerAPI);
  return amerAPI;
};
